import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-fit-data-modal',
  templateUrl: './fit-data-modal.component.pug',
  styleUrls: ['./fit-data-modal.component.scss']
})
export class FitDataModalComponent implements OnInit {

  @Input() data: any;

  fitDataInd: boolean;
  estimatePerformanceOption: 'portfolio' | 'new' = 'portfolio';
  newPercentageValue: number = null;
  portfolioAverageValue: number = null;
  errorMessage: string = '';

  ngOnInit() {
    this.fitDataInd = this.data.fitDataInd;
    // TODO: portfolioAverageValue is currently passed in by the caller with no real data source wired up yet.
    this.portfolioAverageValue = this.data.portfolioAverageValue != null ? this.data.portfolioAverageValue : null;
  }

  selectNewPercentage() {
    this.estimatePerformanceOption = 'new';
  }

  confirm() {
    this.errorMessage = '';

    const result: any = { fit_data_ind: this.fitDataInd };

    if (!this.fitDataInd) {
      if (this.estimatePerformanceOption === 'new') {
        if (this.newPercentageValue === null || this.newPercentageValue === undefined || isNaN(this.newPercentageValue) || this.newPercentageValue < 0 || this.newPercentageValue > 100) {
          this.errorMessage = 'Please enter a valid percentage between 0 and 100.';
          return;
        }
        result.estimate_performance_percentage = this.newPercentageValue;
      } else {
        if (this.portfolioAverageValue === null) {
          this.errorMessage = 'Portfolio average is not available. Please enter a specific percentage instead.';
          return;
        }
        result.estimate_performance_percentage = this.portfolioAverageValue;
      }
    }

    this.data.confirmFunction(result);
    this.data.close();
  }

  close() {
    this.data.close();
  }
}
